<template>
    <div class="custom-actions">
        <span @click="itemRemove" class="table-control-icon delete mobile-button" :data-tooltip="$t('label.delete')">
            <span class="icon icon-trash" aria-hidden="true"></span>
        </span>
        <span @click="itemEdit" class="table-control-icon edit mobile-button" :data-tooltip="$t('label.edit')">
            <span class="icon icon-edit" aria-hidden="true"></span>
        </span>
    </div>
</template>

<script>
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      itemRemove (event) {
        let self = this
        event.stopPropagation()
        this.$dialog.open({
          title: self.$t('message.areYouSure'),
          message: self.$t('message.removeEmployee'),
          okText: self.$t('button.remove'),
          cancelText: self.$t('button.cancel')
        }).then(response => {
          self.$api.delete('/v1/employees/' + self.rowData.id).then(() => {
            self.$events.fire('employee-deleted', {
              employee: self.rowData
            })
            response.close()
          }).catch(error => {
            console.error(error)
            this.$events.fire('message-open', {
              type: 'error',
              message: self.$t('message.somethingWentWrong')
            })
          })
        }).catch(() => {})
      },
      itemEdit (event) {
        event.stopPropagation()
        this.$events.fire('employee-edited', {
          employee: this.rowData
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Settings/Employees/EmployeeActions.vue